export const horizontalBlocks = [
    {
        x: 50,
        y: 50,
        width: 120,
        height: 50,
        color: '#caeefb',
        scroll_speed: 0.5
    },
    {
        x: 400,
        y: 200,
        width: 60,
        height: 40,
        color: '#f8a897',
        scroll_speed: 0.7
    },
    {
        x: 800,
        y: 250,
        width: 30,
        height: 20,
        color: '#ced155',
        scroll_speed: -0.3
    },
    {
        x: 300,
        y: 470,
        width: 129,
        height: 59,
        color: '#f8a897',
        scroll_speed: -0.5
    },
    {
        x: 200,
        y: 375,
        width: 80,
        height: 60,
        color: 'pink',
        scroll_speed: 0.7
    },
    {
        x: 1400,
        y: 80,
        width: 80,
        height: 30,
        color: 'pink',
        scroll_speed: -0.5
    },
    {
        x: 40,
        y: 200,
        width: 60,
        height: 20,
        color: '#974e4d',
        scroll_speed: 0.4

    },
    {
        x: 1200,
        y: 450,
        width: 80,
        height: 35,
        color: '#caeefb',
        scroll_speed: 0.4
    }
]